<div class="ar-charges-container">
  <div
    class="table-tabs-container"
    appTabIconClickShortcut
    appApArChargeGridAddShortcut>
    <div class="info-note" *ngIf="arChargesCrudLocked">
      <app-information-note
        [message]="hawbArChargesBlockedNote"></app-information-note>
    </div>
    <div class="table-tabs-header">
      <div class="table-tabs-title ibc-heading-h7-bold-subtitle">
        <span class="table-tab-name">AR Charge(s)</span>
      </div>
      <div class="tab-icons">
        <div class="">
          <app-svg-icon
            [list]="arChargesHeaderIcons"
            class="icon-section"
            (iconClicked)="onARChargesIconClicked($event)"></app-svg-icon>
        </div>
      </div>
    </div>
    <app-add-inline-edit-table
      class="ar-charges-table"
      [inlineCrudTableCustomizeConfig]="tableColumnConfig"
      [formConfig]="arChargesFormConfig"
      [pageMode]="pageMode"
      [isFrom]="tableName.arChargesForShipmentAndMawb"
      [isEditIconClicked]="isEditClicked"
      [externalDropdownData]="arChargesExternalDropdownData"
      [externalAutocompleteKeys]="arChargesExternalAutocompleteKeys"
      [externalApiControlNames]="arChargesExternalApiControlNames"
      (inlineCrudTableFormValue)="onARChargesGridFormFieldChange($event)"
      (inlineTableSelectionChange)="onARChargesTableSelectionChange($event)"
      (datePickerChange)="onGridDatePickerChange($event)"
      (invoiceNumberClick)="onInvoiceNumberClick($event)"
      (appendChargeRowFromKeyboard)="onAppendChargeRowFromKeyboard($event)">
    </app-add-inline-edit-table>

    <!-- Total Row Section -->
    <div *ngIf="showTotalRow" class="ar-charges-total-row">
      <div class="total-row-container">
        <div class="total-label">
          <span class="">Total Charge Amount : </span>
        </div>
        <div class="total-amount">
          <span class="">$ {{ totalChargeAmount | number: '1.2-2' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
